// extracted by mini-css-extract-plugin
export default {"Black":"#333D47","recipeList":"Gc255d3","recipeListText":"Gd182f7","item":"G9968e7"};